module.exports = __webpack_public_path__ + "img/zifen.57fe6f6d.png";